import React, { memo, useContext } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { i18nContext } from './context/i18n.context';
import { stepContext } from './context/step.context';
import { displayContext } from './context/display.context';
import { UserContext } from './context/user.context';
import AssessmentChooseClient from './AssessmentChooseClient';
import useStartAssessment from './hooks/useStartAssessment';
import { STATUS_STARTED } from './util';

const AssessmentStart = ({ handleNext }) => {
  const { css } = useContext(displayContext);
  const { xt, t } = useContext(i18nContext);
  const { metadata, components, status } = useContext(stepContext);
  const { isPro } = useContext(UserContext);
  const startAssessment = useStartAssessment();
  const PrimaryButton = memo(components().PrimaryButton);
  const IconChevronRight = memo(components().IconChevronRight);
  const handleGetStarted = () => startAssessment(handleNext);
  const terms = metadata.intro?.terms || '';
  const btns = metadata.ui?.buttons || {};
  const btnProps = { styles: { width: !terms ? 'full' : 'auto' } };
  const continueButton = (
    <PrimaryButton classes={css('action-btn')} click={handleGetStarted} {...btnProps}>
      {t(btns.start || 'Continue')}
    </PrimaryButton>
  );

  // TODO do we want to show this message to supporters?
  const restartPrompt = () => {
    return status !== STATUS_STARTED || isPro ? null : (
      <Row>
        <Col>
          <p>
            <span>{t("You started, but didn't finish.")}</span>
            <button onClick={handleGetStarted} className={css('link-btn')}>
              {t('Finish now')} <IconChevronRight />
            </button>
          </p>
        </Col>
      </Row>
    );
  };
  let actionCols = { xs: 12, sm: 6, md: 5, lg: 4 };
  if (!terms) {
    actionCols = { xs: 12, sm: 12, md: 12, lg: 12 };
  }
  const wrpr = ['assessment-intro-actions'];
  if (terms) wrpr.push('with-terms');

  return (
    <div className={css(wrpr)}>
      <Row className={css('assessment-intro-action-terms-container')}>
        {isPro ? (
          <Col>
            <Row>
              <Col>
                <div dangerouslySetInnerHTML={{ __html: xt(terms) }} />
              </Col>
            </Row>
            <Row>
              <Col>
                <AssessmentChooseClient startAssessment={handleGetStarted} />
              </Col>
            </Row>
          </Col>
        ) : (
          <>
            {terms && (
              <Col xs={12} sm={6} md={7} lg={8}>
                <div dangerouslySetInnerHTML={{ __html: xt(terms) }} />
              </Col>
            )}
            <Col {...actionCols} className={css('assessment-intro-action-button-container in-cols')}>
              {continueButton}
            </Col>
          </>
        )}
      </Row>
      {/* Commenting this out for now as this feature isn't supported by the current React assessments.  This serves as a good starting point for when the first assessment that supports this feature is migrated to React. */}
      {/*restartPrompt()*/}
    </div>
  );
};

export default AssessmentStart;
